import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TokenproviderService} from './util/tokenprovider.service';
import {IonicStorageModule} from '@ionic/storage-angular';
import {HttpClientModule} from '@angular/common/http';
import {Device} from '@awesome-cordova-plugins/device/ngx';
import {Camera} from '@awesome-cordova-plugins/camera/ngx';
import {DeviceProviderService} from './util/device-provider.service';
import {AppVersion} from '@awesome-cordova-plugins/app-version/ngx';
import {AndroidPermissions} from '@awesome-cordova-plugins/android-permissions/ngx';
import {Geolocation} from '@awesome-cordova-plugins/geolocation/ngx';
import {File} from '@awesome-cordova-plugins/file/ngx';
import {GoogleMaps} from '@ionic-native/google-maps';
import {InAppBrowser} from '@awesome-cordova-plugins/in-app-browser/ngx';
//import {FileTransfer} from '@awesome-cordova-plugins/file-transfer/ngx';
//import {SplashScreen} from '@awesome-cordova-plugins/splash-screen/ngx';
//import {ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({hardwareBackButton: false}),
    FormsModule,
    ReactiveFormsModule,
    IonicStorageModule.forRoot({
      name: '__mydb',
    }),
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [
    Geolocation,
    HttpClientModule,
    //FCM,
    //SplashScreen,
    //ScreenOrientation,
    TokenproviderService,
    DeviceProviderService,
    File,
    Camera,
    Device,
    GoogleMaps,
    AppVersion,
    InAppBrowser,
    AndroidPermissions,
    //FileTransfer,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
